import thor from "@sl/thor";

const consentsList = window.localStorage.getItem("uc_settings") ?? false;

// When consents are set by the user (not default ones) set Thor consent
window.addEventListener("UC_UI_INITIALIZED", function() {
    if (consentsList && window.localStorage?.uc_user_interaction === "true") {
        thor.onConsent();
    }
});

// When the user updates consents set Thor consents again for new ones
window.addEventListener("UC_UI_CMP_EVENT", (event) => {
    if (["ACCEPT_ALL", "DENY_ALL", "SAVE"].includes(event.detail.type)) {
        thor.onConsent();
    }
});
